import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuController, Platform } from '@ionic/angular';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { BackButtonService } from 'src/app/services/back-button.service';
import { DataProviderService } from 'src/app/services/data-provider.service';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.page.html',
  styleUrls: ['./chat.page.scss'],
})
export class ChatPage implements OnDestroy, OnInit {
  public chatId: string | undefined;
  public visitId: number | undefined;
  public newVisitId: number | undefined;
  public visit: any;
  public backUrl = '';
  public isLoading = true;
  private destroyed$ = new Subject<void>();
  private routerState: any;
  private backButtonSubscription: Subscription;
  private date: string | undefined;
  private dayNumber: string | undefined;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private menuCtrl: MenuController,
    private backButtonService: BackButtonService,
    private platform: Platform,
    private dataService: DataProviderService
  ) {
    this.backButtonSubscription =
      this.platform.backButton.subscribeWithPriority(10, () => {
        this.goBack();
      });
  }

  public ngOnInit(): void {
    this.route.params.pipe(takeUntil(this.destroyed$)).subscribe((params) => {
      this.routerState = this.router.getCurrentNavigation()?.extras.state;
      this.chatId = params.chatId;
      this.visitId = this.routerState?.visitId;
      this.backUrl = this.routerState?.backUrl || '/home';
      if (this.visitId) {
        this.getVisitData(this.visitId.toString());
      } else {
        this.isLoading = false;
      }
    });

    this.backButtonService.showBackButton({
      show: true,
      action: () => {
        this.goBack();
      },
    });
  }

  public getVisitData(visitId: string): void {
    this.dataService
      .getEljakimJob(visitId)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (visit) => {
          this.visit = visit;
          this.newVisitId = visit?.id;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  public ngOnDestroy(): void {
    this.backButtonSubscription?.unsubscribe();
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  ionViewWillEnter() {
    this.menuCtrl.close('menu');
    this.backButtonService.showBackButton({
      show: true,
      action: () => {
        this.goBack();
      },
    });
  }

  public goBack(): void {
    this.router.navigateByUrl(`${this.backUrl}`);
  }
}
